<template>
  <div class="warp">
    <div class="company_heard_tool">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加财务')">添加</el-button>
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="delList">删除</el-button>
    </div>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="index" label="#" width="100" /> -->
        <el-table-column type="selection" width="55" />
        <el-table-column prop="companyAccount" label="企业账号" />
        <el-table-column label="财务名称" prop="name" />
        <el-table-column prop="daquyuList" label="已绑定大区域">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.daquyuList" :key="index" class="flex-center">
              <div>{{ item.name }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="memo" label="备注" />
        <el-table-column prop="address" label="操作" width="250">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="openDialog('编辑财务', scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" style="margin: 6px 0 0" @click="del(scope.row.id)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" width="800px" :title="dialogTitle" :visible.sync="showDialog" append-to-body @close="resetForm">
      <el-form ref="form" label-position="left" :model="form" auto label-width="100px">
        <el-form-item label-width="100px" prop="companyId" label="发布企业账号：">
          <el-select v-model="test" filterable remote clearable placeholder="请输入企业账号进行搜索" :remote-method="getCompanyByAccount" :loading="loading">
            <el-option v-for="item in companyOpt" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <i v-show="searching" class="el-icon-loading" style="margin-left: 10px" />
        </el-form-item>
        <el-form-item label="财务名称：" prop="name">
          <el-input v-model="form.name" style="max-width: 200px" />
        </el-form-item>
        <el-form-item label="绑定大区域：" prop="daquyuIds">
          <el-checkbox-group>
            <el-checkbox-group v-model="form.daquyuIds">
              <el-checkbox v-for="(item, index) in daquyuList" :key="index" :label="item.id" name="type">{{ item.name }}</el-checkbox>
            </el-checkbox-group>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="备注：" prop="memo">
          <el-input v-model="form.memo" style="max-width: 200px" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit(dialogTitle === '添加财务')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/mixins/pagination'
import md5 from 'js-md5' // 引入Md5加密
import { deepClone } from '@/utils'
export default {
  mixins: [pagination],
  data() {
    return {
      tableData: [],
      tableH: 0,
      form: {
        companyAccountId: null,
        companyId: null,
        daquyuIds: [],
        name: '',
        memo: ''
      },
      type: [],
      visible: false,
      showDialog: false,
      dialogTitle: '',
      companyOpt: [],
      daquyuList: [],
      saveType: '',
      loading: true,
      searching: false,
      test: '',
      multipleSelection: []
    }
  },
  mounted() {
    this.getTableList()
    this.tableH = this.$refs.tableWrap.clientHeight
    this.getAllDaquyu()
  },
  methods: {
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
      // console.log(val)
    },
    // 批量删除
    delList() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info('您并没有选中任何数据')
      }
      var ids = []
      this.multipleSelection.forEach((item) => {
        ids.push(item.id)
      })
      console.log(ids)
      var params = {
        ids: ids.toString()
      }
      this.$api.advance
        .yuzhiCaiwuDel(params)
        .then((res) => {
          console.log(res)
          this.$message.success(res)
          this.refresh()
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    getCompanyByAccount(username) {
      this.searching = true
      this.companyOpt = []
      this.$api.company
        .reqCompanyByAccount({ username })
        .then((res) => {
          this.form.companyAccountId = res.companyAccountId
          this.companyOpt = [
            {
              value: res.companyId,
              label: res.companyName
            }
          ]
          this.searching = false
        })
        .catch(() => {
          this.companyOpt = []
          this.searching = false
        })
    },
    handleSubmit(isAdd) {
      if (!this.validateForm()) return
      const form = Object.assign({}, this.form)
      form.daquyuIds = form.daquyuIds.toString()
      if (isAdd) {
        this.loading = true
        this.$api.advance
          .yuzhiCaiwuSave(form)
          .then((res) => {
            console.log('保存')
            this.showDialog = false
            this.getTableList()
            this.$message.success('操作成功')
          })
          .catch((e) => {
            this.loading = false
            this.$message.error(e)
          })
      } else {
        try {
          this.$api.advance
            .yuzhiCaiwuUpdte(form)
            .then((res) => {
              this.showDialog = false
              this.getTableList()
              this.$message.success('操作成功')
            })
            .catch((e) => {
              this.loading = false
              this.$message.error(e)
            })
        } catch (error) {
          console.log(error)
        }
      }
    },
    resetForm() {
      this.$refs.form.resetFields()
    },
    getTableList() {
      this.loading = true
      this.$api.advance
        .caiwuList(this.page)
        .then((res) => {
          this.tableData = res.records
          this.total = res.total
          const ids = res.records.map((item) => item.companyAccountId).join(',')
          this.tableData.forEach((item) => {
            this.getdaquyuIdsByIds({ ids: item.daquyuIds && item.daquyuIds.toString() }, item)
          })
          this.getCompanyAccountByIds({ ids })
          Promise.all([this.getCompanyName({ ids }), this.getCompanyAccountByIds({ ids })]).then(() => {
            this.loading = false
          })
        })
        .catch((e) => {})
    },
    getCompanyName(data) {
      if (!data.ids) return Promise.resolve('1')
      return this.$api.common
        .reqCompanyAccountByIds(data)
        .then((res) => {
          const settingObj = res
          const settingArr = Object.keys(settingObj).map((key) => {
            // console.log(key); //为每个键名
            console.log(settingObj)
            return settingObj[key] // 把每个对象返回出去生成一个新的数组中相当于0:{id:1}
          })
          const companyList = settingArr
          const map = new Map()
          companyList.forEach((item) => {
            map[item.id] = item
          })
          this.tableData.forEach((item) => {
            item.company = map[item.companyAccountId]
          })
          // this.tableData = JSON.parse(JSON.stringify(this.tableData))
          // console.log('tableData', this.tableData)
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    getCompanyAccountByIds(data) {
      return this.$api.company
        .reqCompanyAccountByIds(data)
        .then((res) => {
          this.tableData.forEach((item) => {
            this.$set(item, 'companyAccount', res[item.companyAccountId] && res[item.companyAccountId].username)
            this.loading = false
          })
        })
        .catch(() => {})
    },
    async getdaquyuIdsByIds(data, item) {
      const res = await this.$api.advance.daquyuIds(data)
      this.$set(item, 'daquyuList', res)
    },
    getAllDaquyu() {
      this.$api.advance
        .allDaquyu()
        .then((res) => {
          this.daquyuList = res
        })
        .catch((e) => {})
    },
    openDialog(title, row) {
      this.dialogTitle = title
      this.showDialog = true
      this.test = ''
      this.companyOpt = []
      if (!row) return
      this.$nextTick(() => {
        const { companyAccountId, companyId, daquyuIds, name, memo, id } = row
        this.form = {
          companyAccountId,
          companyId,
          daquyuIds,
          name,
          memo,
          id
        }
        this.companyOpt = [
          {
            label: row.company.companyName,
            value: row.companyId
          }
        ]
        this.test = row.company.companyName
        this.companyOpt = JSON.parse(JSON.stringify(this.companyOpt))
      })
    },
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.getTableList()
    },
    validateForm() {
      let pass
      this.$refs.form.validate((res) => {
        pass = res
      })
      return pass
    },
    del(id) {
      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.advance
          .yuzhiCaiwuDelete({ ids: id })
          .then((res) => {
            this.getTableList()
          })
          .catch((e) => {})
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
